import { matchPath } from 'react-router-dom'

export default (currentPath, options) => matchPath(currentPath, options)?.params || {}
